import React from 'react'
import { Clientes, DadosRelDiaCtaPagar, HeaderPDF, Produto } from '../../../Utils/Types'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import { Funcoes } from '../../../Utils/Funcoes'
import moment from 'moment'
import { DadosRelCtaPagarDetalhado } from '../../../Components/GridProducts/GridRelCtaPagarDetalhado'
import { utils } from 'xlsx'

export class ReportContaPagarPDF {

  private dadosContaPagar: DadosRelDiaCtaPagar[]
  private dadosContaPagarDet: DadosRelCtaPagarDetalhado[]
  private headers: HeaderPDF[]
  private corpoDocumento: any
  private body: any
  private dadosEmpresa: any
  private datai: any
  private dataf: any
  private tipoFiltro: string
  private nomeFornecedor: string

  constructor(dadosContaPagar: DadosRelDiaCtaPagar[], dadosContaPagarDet: DadosRelCtaPagarDetalhado[], headers: HeaderPDF[], datai: string, dataf: string, tipoFiltro: string, nomeFornecedor: string) {

    this.dadosContaPagar = dadosContaPagar
    this.headers = headers
    this.datai = datai ? moment(datai).format('DD/MM/YYYY') : datai
    this.dataf = dataf ? moment(dataf).format('DD/MM/YYYY') : dataf
    this.tipoFiltro = tipoFiltro
    this.dadosContaPagarDet = dadosContaPagarDet
    this.nomeFornecedor = nomeFornecedor
    this.body = []
  }

  async GerarPDFDetalhado(dadosContaPagarDet: DadosRelCtaPagarDetalhado[]) {
    this.dadosEmpresa = Funcoes.GetDadosEmpresa()

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    let dados = dadosContaPagarDet.map((item: DadosRelCtaPagarDetalhado) => {
      return [
        { text: item.ndup, alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: moment(item.dataEmissao).format('DD/MM/YYYY'), alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: moment(item.dataVencimento).format('DD/MM/YYYY'), alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: item.nomeFornecedor || '', alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: Funcoes.numberFormat(item.valor, 'currency', 2, 2) || '', alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: item.observacao || '', alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true], },];
    });

    const footer = (currentPage: number, pageCount: number,) => {
      return [
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [5, 20, 5, 0],
          table: {
            headerRows: 1,
            widths: ['*', '*'],
            body: [
              [
                { text: 'Emissão: ' + moment(new Date()).format('DD/MM/YYYY HH:mm'), alignment: 'left', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },
                { text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },

              ],
            ]
          }
        },
      ]
    };

    const docDefinitions: any = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      pageMargins: [5, 5, 5, 50],
      content: [

        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.dadosEmpresa?.fantasia || '', bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.endereco || '') + (this.dadosEmpresa?.numero ? " N." + this.dadosEmpresa?.numero : '') + ' ' + (this.dadosEmpresa?.bairro || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.cidade || '') + " - " + (this.dadosEmpresa?.uf || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],

            ],
          },
        },

        {
          //[left, top, right, bottom]
          layout: 'noBorders',
          style: 'tableExample',
          table: {
            widths: ['100%'],
            body: [
              [
                { text: `Relatório de contas a pagar ${this.tipoFiltro === 'A' ? 'em aberto' : 'liquidadas'}`, alignment: 'center', fontSize: 15, style: 'header', margin: [0, 1, 0, 1] },
              ],
            ],

          },

        },

        this.datai !== '' || this.dataf !== '' ?

          {
            layout: 'noBorders',
            style: 'tableExample',
            margin: [0, 0, 0, 0],
            table: {
              body: [
                [
                  this.datai !== '' ?
                    {
                      text: [
                        { text: 'Período: ', fontSize: 10, },
                        { text: this.datai, fontSize: 10, bold: true },
                        { text: this.dataf !== '' ? '   à   ' : '', fontSize: 9 },
                        { text: this.dataf, fontSize: 10, bold: true }
                      ],
                      margin: [0, 0, 0, 0,]
                    } : null,
                ],
                [
                  { text: `${this.nomeFornecedor ? 'Fornecedor: ' + this.nomeFornecedor : 'Fornecedor: Não informado'}`, alignment: 'left', fontSize: 10, },
                ]
              ],
            },
          } : null,

        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0, 0, 0],
          table: {
            //[left, top, right, bottom]
            widths: [50, 50, 50, '*', 100, 300],
            body: [
              [
                { text: 'Duplicata', alignment: 'left', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, true, false], bold: true },
                { text: `${this.tipoFiltro === 'A' ? 'Emissão' : 'Vencimento'}`, alignment: 'left', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, true, false], bold: true },
                { text: `${this.tipoFiltro === 'A' ? 'Vencimento' : 'Pagamento'}`, alignment: 'left', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, true, false], bold: true },
                { text: 'Fornecedor', alignment: 'left', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, true, false], bold: true },
                { text: 'Valor(R$)', alignment: 'right', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, true, false], bold: true },
                { text: 'Observação', alignment: 'left', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
              ],
            ],
          },
        },
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            widths: [50, 50, 50, '*', 100, 300],
            body: dados
          },
        }

      ].filter(Boolean),

      footer: footer
    };

    pdfMake.createPdf(docDefinitions).print();
  }

  async GerarPDF(dadosCta: DadosRelDiaCtaPagar[]) {

    this.dadosEmpresa = Funcoes.GetDadosEmpresa()

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    let dados = dadosCta.map((item: DadosRelDiaCtaPagar) => {
      return [
        { text: moment(item.dt_vencimento || '').format('DD/MM/YYYY'), alignment: 'left', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: item.qtd_dup || '', alignment: 'center', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: 'R$ ' + item.total || '', alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, true, true], },
        { text: 'R$ ' + item.acumulado || '', alignment: 'right', fontSize: 9, margin: [0, 2, 0, 2], border: [false, true, false, true], }];
    });

    const footer = (currentPage: number, pageCount: number,) => {
      return [
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [5, 20, 5, 0],
          table: {
            headerRows: 1,
            widths: ['*', '*'],
            body: [
              [
                { text: 'Emissão: ' + moment(new Date()).format('DD/MM/YYYY HH:mm'), alignment: 'left', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },
                { text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },

              ],
            ]
          }
        },
      ]
    };

    const docDefinitions: any = {
      pageSize: 'A4',
      pageMargins: [5, 5, 5, 50],
      content: [

        {
          layout: 'Borders',
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [
              [{ text: this.dadosEmpresa?.fantasia || '', bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.endereco || '') + (this.dadosEmpresa?.numero ? " N." + this.dadosEmpresa?.numero : '') + ' ' + (this.dadosEmpresa?.bairro || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
              [{ text: (this.dadosEmpresa?.cidade || '') + " - " + (this.dadosEmpresa?.uf || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],

            ],
          },
        },

        {
          //[left, top, right, bottom]
          layout: 'noBorders',
          style: 'tableExample',
          table: {
            widths: ['100%'],
            body: [
              [{ text: `Relatório de contas a pagar ${this.tipoFiltro === 'A' ? 'em aberto' : 'liquidadas'}`, alignment: 'center', fontSize: 15, style: 'header', margin: [0, 1, 0, 1] }],
            ],

          },

        },

        this.datai !== '' || this.dataf !== '' ?

          {
            layout: 'noBorders',
            style: 'tableExample',
            margin: [0, 0, 0, 0],
            table: {
              body: [
                [
                  this.datai !== '' ?
                    {
                      text: [
                        { text: 'Período: ', fontSize: 10, },
                        { text: this.datai, fontSize: 10, bold: true },
                        { text: this.dataf !== '' ? '   à   ' : '', fontSize: 9 },
                        { text: this.dataf, fontSize: 10, bold: true }
                      ],
                      margin: [0, 0, 0, 0]
                    } : null,


                ],
                [
                  { text: `${this.nomeFornecedor ? 'Fornecedor: ' + this.nomeFornecedor : 'Fornecedor: Não informado'}`, alignment: 'left', fontSize: 10, },
                ]
              ],
            },
          } : null,

        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            //[left, top, right, bottom]
            widths: ['*', '*', '*', '*'],
            body: [
              [
                { text: 'Data Vencimento', alignment: 'left', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, true, false], bold: true },
                { text: 'Qtd - Duplicatas', alignment: 'center', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, true, false], bold: true },
                { text: 'Total(R$)', alignment: 'right', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, true, false], bold: true },
                { text: 'Acumulado(R$)', alignment: 'right', fontSize: 9, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
              ],
            ],
          },
        },
        {
          layout: 'Borders',
          style: 'tableExample',
          margin: [0, 0, 0, 0],
          table: {
            widths: ['*', "*", '*', '*'],
            body: dados
          },
        }

      ].filter(Boolean),

      footer: footer
    };

    pdfMake.createPdf(docDefinitions).print();

  }

}